module.exports = __webpack_public_path__ + "static/media/line.ff1cb5d8.PNG";